import { ReactComponent as CheckIcon } from '../../assets/icons/check.svg';


const Checkbox = ({ id, checked = false, invalid = false, onChange, children, className = '' }) => {
  const classes = [
    'checkbox',
    checked ? 'is-checked' : '',
    invalid ? 'checkbox--missing' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={classes} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="checkbox__input"
        checked={checked}
        aria-invalid={invalid ? true : undefined}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="checkbox__box" aria-hidden="true">
        <CheckIcon />
      </span>
      <span className="checkbox__text">{children}</span>
    </label>
  );
};

export default Checkbox;
